module.exports = __webpack_public_path__ + "img/2.0 Mhrs Rate Summary.db3b066f.jpg";